module.exports = __webpack_public_path__ + "img/Vector (6).cc1b5cb2.svg";